import { useExchangeStore } from "@app/hooks/trade/exchangeStore";
import React from "react";
import { TradeText } from "./styles";
import { goTo } from "@app/hooks/navigation";
import { useNavigate } from "react-router-dom";
import { Text } from "@/styles/reactnative";
import { useTranslation } from "react-i18next";
import { COLORS } from "@app/constants";
import useTradeStore from '@app/hooks/trade/tradeStore.tsx';

const ContractsColumn = ({ item }) => {
  const { t } = useTranslation();
  const { mutate } = useTradeStore();
  const { EPs } = useExchangeStore()
  const navigate = useNavigate();

  const EP = EPs?.find((item2: any) => +item2.id == +item?.exchange_pairs_id);

  return (
    <TradeText style={{ flexDirection: "row", width: 'auto', gap: 5, justifyContent: 'left'}}>
      <TradeText
        style={{
          flexDirection: "column",
          cursor: "pointer",
          width: 'auto',
          alignItems: 'center'
        }}
        onClick={() => {

          if (EP) {
            mutate({
              ep_id: EP.id,
              ...EP
            });

            navigate(`/trade/${EP.id}`, { replace: true });
          }
          // navigate("/trade/" + EP?.id);
        }}
      >
        <Text size={10}>{EP?.pairs}</Text>
        <Text
          style={{
            color: "orange",
            fontSize: 10,
            whiteSpace: "nowrap",
          }}
        >
          {item?.cross_iso === "C" ? t("cross") : t("iso")} {item?.leverage}X
        </Text>
      </TradeText>
      <Text
        style={{
          color: item?.long_short === "L" ? COLORS.lightGreen : COLORS.lightRed,
        }}
      >
        {item?.long_short === "L" ? t("long") : t("short")}
      </Text>
    </TradeText>
  );
};

export default React.memo(ContractsColumn);
